import { HStack } from "@chakra-ui/react";
import type { ReactNode } from "react";
import React from "react";

export function DataSourceDrawerFooter({ children }: { children: ReactNode }) {
  return (
    <HStack
      w="full"
      spacing={4}
      justifyContent="flex-end"
      py={4}
      px={4}
      borderTopWidth="1px"
      borderColor="gray.300"
    >
      {children}
    </HStack>
  );
}
